import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
//∫import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsService {

  
  constructor(private http: HttpClient){}

  postPushNotification( body: any, url: string = null) {
    body["app_id"]=environment.appId;
    body["channel_for_external_user_ids"]="push";
    return this.http.post(url || environment.pushNotificationUrl, body);
  } 

}
